enum QueryPriorities {
    system = 0,
    high = 1,
    normal = 2,
    low = 3
}

export default QueryPriorities;